import type { SVGProps } from 'react'
const SvgUnSecureFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.09961 6.44434V11.1006C6.09969 13.097 6.66051 14.9109 7.78223 16.5439C8.8976 18.1677 10.3038 19.2492 12 19.7949C13.6962 19.2492 15.1024 18.1687 16.2178 16.5449C17.3395 14.9118 17.9003 13.098 17.9004 11.1016V6.44434L12 4.25195L6.09961 6.44434ZM19.0996 11.1006C19.0995 13.4238 18.429 15.5146 17.0879 17.3691C15.7475 19.2226 14.0604 20.4538 12.0283 21.0586L12 21.0674L11.9717 21.0586C9.93953 20.4552 8.25255 19.2246 6.91211 17.3711C5.57098 15.5165 4.90047 13.4251 4.90039 11.1006V5.62305L4.96484 5.59863L11.9648 2.9834L12 2.9707L12.0352 2.9834L19.0352 5.59863L19.0996 5.62305V11.1006Z"
      fill="#E22828"
      stroke="#E22828"
      strokeWidth="0.2"
    />
    <path
      d="M9.35156 8.90039C9.47543 8.90039 9.58442 8.94487 9.67188 9.03223L12 11.3604L14.3281 9.03223C14.4134 8.94708 14.5215 8.9043 14.6445 8.90234C14.7698 8.9005 14.8797 8.94422 14.9678 9.03223C15.055 9.1196 15.0995 9.22785 15.0996 9.35156C15.0996 9.47543 15.0551 9.58442 14.9678 9.67188L12.6396 12L14.9678 14.3281C15.0529 14.4134 15.0957 14.5215 15.0977 14.6445C15.0995 14.7698 15.0558 14.8797 14.9678 14.9678C14.8804 15.055 14.7722 15.0995 14.6484 15.0996C14.5246 15.0996 14.4156 15.0551 14.3281 14.9678L12 12.6396L9.67188 14.9678C9.58663 15.0529 9.47853 15.0957 9.35547 15.0977C9.23015 15.0995 9.12034 15.0558 9.03223 14.9678C8.94496 14.8804 8.90048 14.7722 8.90039 14.6484C8.90039 14.5246 8.94487 14.4156 9.03223 14.3281L11.3604 12L9.03223 9.67188C8.94708 9.58663 8.9043 9.47853 8.90234 9.35547C8.9005 9.23015 8.94422 9.12034 9.03223 9.03223C9.1196 8.94496 9.22785 8.90048 9.35156 8.90039Z"
      fill="#E22828"
      stroke="#E22828"
      strokeWidth="0.2"
    />
  </svg>
)

export default SvgUnSecureFile
